module.exports = __webpack_public_path__ + "assets/outline-cancel_presentation-24px.svg?26ff7df7f47eb9ea9b40d5cd8f357794";